<template>
  <v-container id="locations-table" fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="locationList"
        :options.sync="options"
        :server-items-length="totalLocations"
        :footer-props="footerProps"
        :loading="loadingData"
        :loading-text="$t('location.loadingText')"
        :no-data-text="$t('location.noLocation')"
        mobile-breakpoint="768"
        item-key="id"
        :header-props="headerProps"
      >
        <template v-slot:top v-if="isCustomerService">
          <v-toolbar flat>
            <v-badge :content="nbActiveFilters" :value="nbActiveFilters" overlap>
              <v-btn outlined color="primary" @click="displayFilters = !displayFilters">
                <v-icon>mdi-filter-plus-outline</v-icon>
              </v-btn>
            </v-badge>
            <v-spacer />
            <v-btn color="primary" class="mr-1" outlined @click="exportCSV()" :disabled="loadingData">
              <v-icon>mdi-file-delimited</v-icon>
            </v-btn>
            <v-btn color="primary" class="mr-1" outlined :to="'/locations/add'">
              <v-icon>mdi-home-plus-outline</v-icon>
            </v-btn>
            <v-btn color="primary" outlined @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.services.delivery_in_store="{ item }">
          <v-simple-checkbox v-model="item.services.delivery_in_store" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.services.click_and_collect="{ item }">
          <v-simple-checkbox v-model="item.services.click_and_collect" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.services.click_and_reserve="{ item }">
          <v-simple-checkbox v-model="item.services.click_and_reserve" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.services.ship_from_store="{ item }">
          <v-simple-checkbox v-model="item.services.ship_from_store" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            text
            :class="[$vuetify.breakpoint.width >= 768 ? '' : 'pr-0']"
            color="primary"
            @click="editLocation(item)"
          >
            {{ $t('location.edit') }}
          </v-btn>
        </template>
        <!-- <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editLocation(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteLocation(item)">
                        mdi-delete
                    </v-icon>
                </template> -->
      </v-data-table>
    </v-card>
    <filter-dialog
      :key="formFiltersKey"
      v-model="displayFilters"
      :title="$t('location.filterLocations')"
      :fields="formFilters"
      @confirm="filter"
      :loadingData="loadingData"
    ></filter-dialog>
  </v-container>
</template>

<script>
  import { EventBus } from '../../event-bus'
  import { mapState } from 'vuex'

  export default {
    name: 'LocationTable',
    data() {
      return {
        formFiltersKey: Date.now(),
        locations: [],
        loadingData: false,
        options: {
          itemsPerPage: 15,
        },
        displayFilters: false,
        filters: [],
        totalLocations: 0,
      }
    },
    activated() {
      if (this.$store.state.previousPath.split('/')[1] != 'locations') {
        this.formFiltersKey = Date.now()
        this.filters = []
        this.options.itemsPerPage = 15
        this.options.page = 1
        this.options.sortBy = []
        this.options.sortDesc = []
      }
      this.locations = []
      this.filter(this.filters)
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    computed: {
      ...mapState(['isCustomerService', 'currentStore']),
      locationList: function () {
        for (let location of this.locations) {
          location.type = this.$t(`location.${location.type}`)
        }
        if (this.isCustomerService) {
          return this.locations
        } else {
          return this.locations.filter((location) => location.location_id == this.currentStore)
        }
      },
      // return this.locations.map( (store) => {
      //     let locationData = {
      //         name: store.name,
      //         external_ref: store.references.external_ref,
      //         type: store.references.type
      //     }
      //     return storeData
      //     // store.external_ref = store.references.external_ref
      //     // store.type = store.references.type
      //     // delete store.references
      //     // return store
      // })
      // }
      headers() {
        if (this.$vuetify.breakpoint.width < 769) {
          return [
            {
              text: this.$t('location.name'),
              value: 'name',
            },
            {
              text: this.$t('location.locationType'),
              value: 'type',
            },
            {
              text: this.$t('subOrder.inStorePickup'),
              value: 'services.delivery_in_store',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.clickAndCollect'),
              value: 'services.click_and_collect',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.clickAndReserve'),
              value: 'services.click_and_reserve',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.shipFromStore'),
              value: 'services.ship_from_store',
              align: 'center',
              sortable: false,
            },
            {
              text: '',
              value: 'action',
              sortable: false,
            },
          ]
        } else {
          return [
            {
              text: this.$t('location.locationIdentifier'),
              value: 'location_id',
            },
            {
              text: this.$t('location.name'),
              value: 'name',
            },
            {
              text: this.$t('location.locationType'),
              value: 'type',
            },
            {
              text: this.$t('subOrder.inStorePickup'),
              value: 'services.delivery_in_store',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.clickAndCollect'),
              value: 'services.click_and_collect',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.clickAndReserve'),
              value: 'services.click_and_reserve',
              align: 'center',
              sortable: false,
            },
            {
              text: this.$t('subOrder.shipFromStore'),
              value: 'services.ship_from_store',
              align: 'center',
              sortable: false,
            },
            {
              text: '',
              value: 'action',
              sortable: false,
            },
          ]
        }
      },
      formFilters() {
        return [
          {
            text: 'location_id',
            value: 'location_id',
            filterType: 'text',
          },
          {
            text: 'name',
            value: 'name',
            filterType: 'text',
          },
          {
            text: 'type',
            value: 'type',
            filterType: 'array',
            arrayValues: [
              { text: this.$t('location.shop'), value: 'shop' },
              { text: this.$t('location.warehouse'), value: 'warehouse' },
            ],
          },
          {
            text: this.$t('location.establishmentType'),
            value: 'establishment_type',
            filterType: 'array',
            arrayValues: [
              { text: this.$t('location.affiliated'), value: 'affiliated' },
              { text: this.$t('location.franchise'), value: 'franchise' },
              { text: this.$t('location.succursale'), value: 'succursale' },
              { text: this.$t('location.corner'), value: 'corner' },
              { text: this.$t('location.outlet'), value: 'outlet' },
              { text: this.$t('location.other'), value: 'other' },
            ],
          },
          {
            text: this.$t('location.services'),
            value: 'services',
            filterType: 'array',
            arrayValues: [
              {
                text: this.$t('subOrder.inStorePickup'),
                value: 'delivery_in_store',
              },
              {
                text: this.$t('subOrder.clickAndCollect'),
                value: 'click_and_collect',
              },
              {
                text: this.$t('subOrder.clickAndReserve'),
                value: 'click_and_reserve',
              },
              {
                text: this.$t('subOrder.shipFromStore'),
                value: 'ship_from_store',
              },
            ],
          },
        ]
      },
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('location.locationsPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('order.sortByText'),
        }
      },
      nbActiveFilters: function () {
        return this.filters.filter((filter) => filter.active).length
      },
    },
    methods: {
      list() {
        this.loadingData = true
        let myInit = this.buildMyInit()
        this.$Amplify.API.get('locations', '/v1/int/locations', myInit)
          .then((res) => {
            this.totalLocations = res.nbLocations
            this.locations = res.data
            if (this.totalLocations < (this.options.page - 1) * this.options.itemsPerPage + 1) {
              let pageNumber = Math.floor(this.totalLocations / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
            this.loadingData = false
          })
          .catch(() => {
            this.loadingData = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('orderWorkflow.locationsLoadingErrorMessage'),
              color: 'error',
            })
          })
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        EventBus.$emit('reLoadCounter')
        this.list()
      },
      editLocation(item) {
        this.$router.push(`/locations/${item.location_id}`)
      },
      filter(filters) {
        this.filters = filters
        this.reloadList()
      },
      exportCSV() {
        EventBus.$emit('displaySnackbar', {
          display: true,
          text: this.$t('order.CSVGenerationInProgress'),
          color: 'success',
        })
        let sortedData = []
        let csvHeaders = [
          { text: 'location_id', value: 'location_id' },
          { text: 'name', value: 'name' },
          { text: 'type', value: 'type' },
          { text: this.$t('location.establishmentType'), value: 'establishment_type' },
          { text: this.$t('subOrder.inStorePickup'), value: 'delivery_in_store' },
          { text: this.$t('subOrder.clickAndCollect'), value: 'click_and_collect' },
          { text: this.$t('subOrder.clickAndReserve'), value: 'click_and_reserve' },
          { text: this.$t('subOrder.shipFromStore'), value: 'ship_from_store' },
        ]
        /* get order items without pagination */
        this.loadingData = true
        let myInit = this.buildMyInit(false)
        this.$Amplify.API.get('locations', '/v1/int/locations', myInit)
          .then((res) => {
            sortedData = res.data
            this.loadingData = false
            // this.list()
            let fileName = 'LOCATIONS.csv'

            // from here we build the CSV file and we download it
            let fileExport = []

            //we create CSV header and add them to the table which will become the CSV
            let columns = []
            for (let header of csvHeaders) {
              if (header.text != '') {
                columns.push(header.text)
              }
            }
            let columnsExport = columns.join(';')
            fileExport.push([columnsExport])

            //we format data as we do for the current displayed data in the template view
            //and add them to the table which will become the CSV
            for (var tableLine of sortedData) {
              let tableLineFiltered = []
              for (let header of csvHeaders) {
                let value = this.getData(header.value, tableLine)
                // Escape values that contain semicolons, quotes, newlines, or carriage returns by wrapping in quotes
                const stringValue = value != null ? value.toString() : ''
                if (stringValue && /[;"\n\r]/.test(stringValue)) {
                  value = '"' + stringValue.replace(/"/g, '""') + '"'
                } else {
                  value = stringValue
                }
                tableLineFiltered.push(value)
              }
              fileExport.push(tableLineFiltered.join(';'))
            }
            //we create the CSV from the previously mentionned table in comments
            const url = window.URL.createObjectURL(new Blob([fileExport.join('\n')]))
            // we create an <a> element and we simulate a click on it to trigger the downloading
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            this.loading = false
          })
          .catch((e) => {
            console.log(e)
            this.loadingData = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: 'error during orders loading',
              color: 'error',
            })
          })
      },
      buildMyInit(pagination = true) {
        let { page, itemsPerPage, sortDesc, sortBy } = this.options
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            sortBy: sortBy.length == 0 ? 'location_id' : sortBy,
            sortDesc: sortDesc.length == 0 ? false : sortDesc,
          },
        }
        if (pagination) {
          myInit.queryStringParameters.page = page
          myInit.queryStringParameters.itemsPerPage = itemsPerPage
        } else {
          myInit.queryStringParameters.itemsPerPage = false
        }
        let filters = {}
        for (let filter of this.filters) {
          if (filter.active) {
            filters[filter.name] = filter.value
          }
        }
        if (Object.entries(filters).length != 0) {
          myInit.queryStringParameters.filters = JSON.stringify(filters)
        }
        return myInit
      },
      getData: function (name, order) {
        if (name == 'delivery_in_store') {
          return order.services.delivery_in_store
        } else if (name == 'click_and_collect') {
          return order.services.click_and_collect
        } else if (name == 'click_and_reserve') {
          return order.services.click_and_reserve
        } else if (name == 'ship_from_store') {
          return order.services.ship_from_store
        } else return order[name]
      },
    },
  }
</script>
